// src/components/CustomerTable.js
import React from "react";
import {
  Table,
  TableHeader,
  TableCell,
  ActionButton
} from "../styles/StyledComponents";
import Badge from "../components/Badge";

const CustomerTable = ({ customers, onEdit }) => {
  const truncateText = (text, maxLength) => {
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  return (
    <Table>
      <thead>
        <tr>
          <TableHeader>Nome</TableHeader>
          <TableHeader>Endereço</TableHeader>
          <TableHeader>Bairro</TableHeader>
          <TableHeader>Tipo</TableHeader>
          <TableHeader align="center">Equipamentos</TableHeader>
          <TableHeader>Contrato</TableHeader>
          <TableHeader>Tipo Contrato</TableHeader>
          <TableHeader>Status</TableHeader>
          <TableHeader>Criado em</TableHeader>
          <TableHeader align="center">Ações</TableHeader>
        </tr>
      </thead>
      <tbody>
        {customers.map(customer => {
          const formattedDate = new Date(
            customer.createdAt
          ).toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
          });

          // Concatenate address and number, then apply truncation
          const fullAddress = `${customer.address}, ${customer.number}`;
          const truncatedAddress = truncateText(fullAddress, 30);

          return (
            <tr key={customer._id}>
              <TableCell>
                {truncateText(customer.name, 25)}
              </TableCell>
              <TableCell>
                {truncatedAddress}
              </TableCell>
              <TableCell>
                {customer.neighborhood}
              </TableCell>
              <TableCell>
                {customer.type}
              </TableCell>
              <TableCell align="center">
                {customer.equipmentCount}
              </TableCell>
              <TableCell>
                {customer.contractNumber}
              </TableCell>
              <TableCell>
                {customer.tipoContrato}
              </TableCell>
              <TableCell>
                <Badge status={customer.status} />
              </TableCell>
              <TableCell>
                {formattedDate}
              </TableCell>
              <TableCell align="center">
                <ActionButton onClick={() => onEdit(customer)}>
                  Editar
                </ActionButton>
              </TableCell>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default CustomerTable;
